import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import BackgroundBG from "../subparts/backgrounds/BackgroundBG";

export default class Background extends Part {
  static id = 'Background';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Background';
    this.categoryEnabled = false;
    this.relatedGroupNames = ["BG"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "BG":
        relatedItemName = "backgroundBG";
        RelatedItemClass = BackgroundBG;
        break;
      default:
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
